"use client";

import { Link } from "@/components/common/Link";
export default function () {
  return <section data-section-id="36" id="profileintroduction" className="bg-background text-foreground py-20 md:py-28 lg:py-32 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4 flex flex-col gap-8">
            <nav aria-label="breadcrumb" className="font-mono text-xs tracking-widest text-muted-foreground uppercase">
              <Link to="/HomePage" className="hover:text-foreground transition-colors">
                HOME
              </Link>
              <span className="mx-2">/</span>
              <Link to="/OurStoryPage" className="hover:text-foreground transition-colors">
                OUR STORY
              </Link>
            </nav>

            <div className="font-mono text-xs tracking-[0.2em] text-primary uppercase">
              <span className="block">01 /</span>
              <span className="block mt-1">THE FIRM</span>
            </div>

            <div className="relative w-full max-w-xs aspect-[3/4] overflow-hidden rounded-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_interior.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_interior.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_interior.webp-wvc-sizes" alt="Professional law office interior in Hollywood Florida" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale contrast-110" />
              <div className="absolute inset-0 pointer-events-none opacity-30 mix-blend-overlay" style={{
              backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.6'/></svg>\")"
            }} />
            </div>
          </div>

          {}
          <div className="lg:col-span-8 flex flex-col gap-12">
            {}
            <div>
              <div className="font-mono text-xs tracking-[0.2em] text-[hsl(43_35%_60%)] uppercase mb-4">
                プロフィール
              </div>
              <h1 className="font-serif font-light leading-[1.1] tracking-tight" style={{
              fontSize: "clamp(2.5rem, 6vw, 5.5rem)"
            }}>
                南フロリダで40年以上の実務経験
              </h1>
            </div>

            {}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 max-w-3xl prose">
              <div className="font-default text-base leading-relaxed text-muted-foreground">
                <p><span className="float-left font-serif text-primary mr-3 mt-1 leading-[0.8]" data-ast-id="f:/src/pages/MollyLevinAttorney/sections/ProfileIntroduction.tsx|sig:8l57qt" data-ast-start="2913" data-ast-end="3193" style={{
                  fontSize: '5rem'
                }}>M</span>orrie I.Levine (モーリー・I・レヴィーン) 弁護士は、1983年以来、南フロリダのビジネスオーナーやご家族に対し、専門性に基づいた法務サービスを提供しています。大手事務所のような大量処理型ではなく、個々のクライアントに向き合うブティックファームとして、細やかな配慮と個々の案件に応じた法的助言を提供します。</p>
              </div>
              <div className="font-default text-base leading-relaxed text-muted-foreground space-y-4">
                <p>
                  企業法務・事業承継から不動産取引、遺産相続・プロベートに至るまで、多岐にわたる法分野を総合的にサポートします。お客様のビジネスと生活を包括的に見据え、円滑な移行と法的リスクの管理を実現します。
                </p>
                <p>
                  複雑な法的手続きや重要な意思決定において、常に冷静かつ的確な助言を行い、お客様の法的利益を守るため適切なサポートを提供します。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}